<div class="image-only" >
  <div class="container-fluid p-0" *ngIf="data.mainImage?.url">
    <div class="image-wrapper">
      <img class="image" [defaultImage]="data.mainImage.sizes.thumbnail"  [lazyLoad]="data.mainImage.url" [alt]="data.mainImage.alt">
    </div>
  </div>
</div>

